import {
  ComponentProps,
  Fragment,
  forwardRef,
  ForwardRefExoticComponent,
  RefAttributes,
  FC,
  Ref,
} from "react";
import { Tab } from "@headlessui/react";
import classNames from "classnames";
import { PageLayout } from "../../PageLayout/PageLayout";
import {
  PagesCarousel,
  PagesCarouselProps,
} from "../PagesCarousel/PagesCarousel";

type NavTabType = typeof Tab & {
  CarouselPanels: (props: PagesCarouselProps) => JSX.Element;
  NavTab: ForwardRefExoticComponent<
    ComponentProps<FC> & RefAttributes<HTMLElement>
  >;
};

const NavTab = (
  props: ComponentProps<FC>,
  ref: Ref<HTMLElement> | undefined
) => (
  <Tab
    style={{ borderRadius: "10px 10px 0 0" }}
    className={({ selected }) =>
      classNames("p-2 whitespace-nowrap text-base", {
        "outline-none font-semibold px-4 bg-[#002c5a] text-white": selected,
        "border-b border-transparent text-[#002c5a] font-normal": !selected,
      })
    }
    ref={ref}
    {...props}
  />
);

NavTab.displayName = "NavTab";
NavTab.NavTab = forwardRef(NavTab) as NavTabType["NavTab"];
NavTab.NavTab.displayName = "NavTab.NavTab";
NavTab.Group = Tab.Group;

type NavTabListType = typeof Tab.List;
const NavTabList: NavTabListType = (props) => (
  <nav className="overflow-y-auto lg:overflow-y-visible w-full bg-white border-b border-gray-200 shadow-md scroll-hidden">
    <Tab.List
      className="container flex flex-nowrap items-end mx-auto mt-3 scroll-hidden"
      {...props}
    />
  </nav>
);
NavTabList.displayName = "NavTabList";
NavTab.List = NavTabList;

const NavTabPanels = (props: PagesCarouselProps) => (
  <PagesCarousel {...props}>{props.children}</PagesCarousel>
);
NavTab.CarouselPanels = NavTabPanels;
NavTab.Panels = Tab.Panels;

type NavTabPanelType = typeof Tab.Panel;
const NavTabPanel: NavTabPanelType = (props) => (
  <PageLayout>
    <Fragment {...props} />
  </PageLayout>
);
NavTabPanel.displayName = "NavTabPanel";
NavTab.Panel = NavTabPanel;

export { NavTab };
